"use client";

import React from "react";
import { motion, AnimatePresence } from "motion/react";
import { AlertCircle } from "lucide-react";
import type { FormFieldProps } from "@/types/contact";
import s from "./contact.module.css";

export function FormField({
  id,
  label,
  required = false,
  optional = false,
  error,
  children,
  className = "",
}: FormFieldProps & { optional?: boolean }) {
  return (
    <div className={`${s.field} ${className}`}>
      <label htmlFor={id} className={s.label}>
        {label}
        {required && (
          <span className={s.req} aria-hidden="true">
            *
          </span>
        )}
        {optional && <span className={s.optional}>Optional</span>}
      </label>

      {children}

      <AnimatePresence mode="wait" initial={false}>
        {error && (
          <motion.div
            key={`err-${id}`}
            initial={{ opacity: 0, y: -4, height: 0 }}
            animate={{ opacity: 1, y: 0, height: "auto" }}
            exit={{ opacity: 0, y: -4, height: 0 }}
            transition={{ duration: 0.22, ease: [0.22, 1, 0.36, 1] }}
            className={s.errorMsg}
            role="alert"
            aria-live="polite"
            id={`${id}-error`}
          >
            <AlertCircle size={13} strokeWidth={2.4} aria-hidden="true" />
            <span>{error}</span>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}